import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2 } from "lucide-react";

interface AIReasoningProps {
  reasoning: string;
}

export const AIReasoning = ({ reasoning }: AIReasoningProps) => {
  if (!reasoning) return null;

  return (
    <Card className="border-border/30 bg-muted/10">
      <CardContent className="py-3 px-4">
        <div className="flex items-start gap-3">
          <CheckCircle2 className="h-4 w-4 text-muted-foreground mt-0.5 shrink-0" />
          <div>
            <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-1">
              Vollständigkeit des Entscheidungsraums
            </p>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {reasoning}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
